<div class="container-fluid">
    <section>
        <router-outlet></router-outlet>
        <router-outlet name="popup"></router-outlet>
        <!-- Dedicated router outlet for displaying germplasm details popup -->
        <router-outlet name="germplasmDetailsPopup"></router-outlet>
        <!-- Dedicated router outlet for displaying lot details popup -->
        <router-outlet name="lotDetailPopup"></router-outlet>
    </section>
</div>
<jhi-alert-error></jhi-alert-error>
<jhi-alert></jhi-alert>
<loading-indicator [detectRouteTransitions]="true"></loading-indicator>
